import Siema from 'siema';

const siema = document.querySelector('[data-siema]');
const next  = document.querySelector('[data-siema-next]');
const prev  = document.querySelector('[data-siema-prev]');

if (siema && next && prev) {
    const slider = new Siema({
        selector: siema,
        duration: 200,
        easing: 'ease-out',
        perPage: 1,
        startIndex: 0,
        draggable: true,
        multipleDrag: true,
        threshold: 20,
        loop: true,
        rtl: false,
        onInit: () => {},
        onChange: () => {},
    });

    next.addEventListener('click', () => {
        slider.next();
    });
    prev.addEventListener('click', () => {
        slider.prev();
    });
}